import React from 'react';
import {observer} from 'mobx-react';

const ProjectPTOCell = observer(({model, parent}) => {
  if (model.id) return null;

  return (
    <div>{parent.ptoTotal}</div>
  );
});

export default ProjectPTOCell;
